import React from "react";
import { useNavigate } from "react-router-dom";
import "./Slider.css";
import sliderImg from "../../assets/slider.jpeg";

const Slider = () => {
  const navigate = useNavigate();

  const handleNavigateToContact = () => {
    navigate("/contact"); 
  };

  return (
    <div className="hero-slider" style={{ backgroundImage: `url(${sliderImg})` }}>
      <div className="overlay"></div>

      <div className="hero-content">
        <h2>Welcome</h2>
        <h2>To</h2>
        <h1>Vijay Software Solutions</h1>
        <p>Innovative IT solutions tailored to drive your business forward.</p>
        <button onClick={handleNavigateToContact}>Get in Touch</button>
      </div>
    </div>
  );
};

export default Slider;
